import { styled } from "@stitches/react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { TaoList } from "@/types/tao-routing";
import { Button } from "@/vendor/Forge/dist";

const Wrapper = styled("div", {
    display: "flex",
    flexFlow: "column",
});

const ContentHeaderWrapper = styled("div", {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "0px",
});

const ContentWrapper = styled("div", {
    border: "1px solid #B6B7B7",
    padding: "10px",
    marginBottom: "10px",
    width: "100%",
    borderRadius: "5px",

    "& ul": {
        display: "flex",
        flexFlow: "row",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
    },
    "& ul li": {
        width: "250px",
        wordWrap: "break-word",
    },
});

const ListWrapper = styled("div", {
    maxHeight: "213px",
    overflowY: "scroll",
});

const BottomContentWrapper = styled("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
});

interface Props {
    selectedDepartments: string[];
    selectedProviders: string[];
    selectedGenus: string[];
    selectedBucket: string[];
    selectedOrderTypes: string[];
    priority: string | undefined;
}

interface SelectedTaoList {
    selectedTaoData: TaoList[];
    isDuplicate?: boolean;
    isEdit?: boolean;
  }

const TaoConfirmation = ({
    selectedDepartments,
    selectedProviders,
    selectedGenus,
    selectedBucket,
    selectedOrderTypes,
    priority,
}: Props) => {
    const { selectedTaoData, isEdit, isDuplicate } = useLocation().state as SelectedTaoList ?? [];
    const navigate = useNavigate();

    return (
        <Wrapper>
            <ContentWrapper>
                <ContentHeaderWrapper>
                    <p>Departments</p>
                    <Button variant="tertiary" onClick={() => { navigate('/tao-routing/tao-editor?currentStep=departments', { state: { selectedTaoData: selectedTaoData, isEdit, isDuplicate  } } ); }}>Edit</Button>
                </ContentHeaderWrapper>
                <ListWrapper>
                    <ul>
                        {selectedDepartments.map((department) => (
                                <li key={department}>{department}</li>
                        ))}
                    </ul>
                </ListWrapper>
            </ContentWrapper>
            <ContentWrapper>
                <ContentHeaderWrapper>
                    <p>Provider</p>
                    <Button variant="tertiary" onClick={() => { navigate('/tao-routing/tao-editor?currentStep=providers', { state: { selectedTaoData: selectedTaoData, isEdit, isDuplicate  } } ); }}>Edit</Button>
                </ContentHeaderWrapper>
                <ListWrapper>
                    <ul>
                        {selectedProviders.map((provider) => (
                                <li key={provider}>{provider}</li>
                        ))}
                    </ul>
                </ListWrapper>
            </ContentWrapper>
            <ContentWrapper>
                <ContentHeaderWrapper>
                    <p>Order Type</p>
                    <Button variant="tertiary" onClick={() => { navigate('/tao-routing/tao-editor?currentStep=genus', { state: { selectedTaoData: selectedTaoData, isEdit, isDuplicate  } } ); }}>Edit</Button>
                </ContentHeaderWrapper>
                <ListWrapper>
                    <ul>
                        {selectedOrderTypes.map((orderType) => (
                                <li key={orderType}>{orderType}</li>
                        ))}
                    </ul>
                </ListWrapper>
            </ContentWrapper>
            <ContentWrapper>
                <ContentHeaderWrapper>
                    <p>Genus</p>
                    <Button variant="tertiary" onClick={() => { navigate('/tao-routing/tao-editor?currentStep=genus', { state: { selectedTaoData: selectedTaoData, isEdit, isDuplicate  } } ); }}>Edit</Button>
                </ContentHeaderWrapper>
                <ListWrapper>
                    <ul>
                        {selectedGenus.map((genus) => (
                                <li key={genus}>{genus}</li>
                        ))}
                    </ul>
                </ListWrapper>
            </ContentWrapper>
            <BottomContentWrapper>
                <ContentWrapper>
                    <ContentHeaderWrapper>
                        <p>Assign to Bucket</p>
                        <Button variant="tertiary" onClick={() => { navigate('/tao-routing/tao-editor?currentStep=bucket', { state: { selectedTaoData: selectedTaoData, isEdit, isDuplicate  } } ); }}>Edit</Button>
                    </ContentHeaderWrapper>
                    <ListWrapper>
                        <ul>
                            {selectedBucket.map((bucket) => (
                                    <li key={bucket}>{bucket}</li>
                            ))}
                        </ul>
                    </ListWrapper>
                </ContentWrapper>
                <ContentWrapper>
                    <ContentHeaderWrapper>
                        <p>Priority</p>
                        <Button variant="tertiary" onClick={() => { navigate('/tao-routing/tao-editor?currentStep=bucket', { state: { selectedTaoData: selectedTaoData, isEdit, isDuplicate  } } ); }}>Edit</Button>
                    </ContentHeaderWrapper>
                    <ListWrapper>
                        <ul>
                           {priority ?  <li key={priority}>{priority}</li> : <></>}
                        </ul>
                    </ListWrapper>
                </ContentWrapper>
            </BottomContentWrapper>
        </Wrapper>
    );
};

export default TaoConfirmation;
